import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Badge, Button} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Badge, {
            'children': 'Message'
        }),
        _$cc(Badge, {
            'children': (
                _$cc(Button, {
                    'children': 'Message'
                })
            )
        })
    ], 4);
};